import {
  SET_BRANDS_STATIONS_V2
} from "redux/reducers/brands/brandsReducer";

import {
  STATIONS_BY_COMPANIES,
  SET_COMPANIES_V2,
  LOAD_COMPANIES_V2,
  SET_COMPANIES_GOD,
  CHANGE_STATION_CONFIGURATIONS,
} from "redux/reducers/companies/companiesReducer";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { stationConfigurationsTypes } from "redux/reducers/stationConfigurations/types"

import { api_get, PROYECT, api_put } from "../../../services/api";

const { SET_COMPANY_DATA } = stationConfigurationsTypes;

const url = `${process.env.REACT_APP_URL}${PROYECT}/companies`;

export const getCompaniesV2 = () => {
  return async (dispatch) => {
    dispatch(startRequestComp('loadingStations'));
    dispatch({ type: LOAD_COMPANIES_V2 })
    await api_get(url).then(resp => {
      dispatch({
        type: SET_COMPANIES_V2,
        payload: resp.companies
      })
      dispatch({
        type: SET_BRANDS_STATIONS_V2,
        payload: resp.companies
      })
    }).catch(err => {
      dispatch(setSnackbar(err))
    })
    dispatch(stopRequestComp('loadingStations'))
  }
}

export const getCompaniesGod = () => {
  return async dispatch => {
    try {
      const response = await api_get(`${url}/god`)
      dispatch({
        type: SET_COMPANIES_GOD,
        payload: response.companies
      })
    } catch (err) {
      dispatch(setSnackbar(err))
    }
  }
}

export const getStationsByCompanies = (id) => {
  return (dispatch) => {
    dispatch({
      type: STATIONS_BY_COMPANIES,
      payload: id
    })
  }
}

export const changeStationConfigurations = (form, action = null) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/stations/${form?.id}/digital-inventories`;
  return async (dispatch) => {
    dispatch(startRequestComp('loadingStationsActions'));
    dispatch({ type: LOAD_COMPANIES_V2 })
    await api_put(url, form).then(resp => {
      const newForm = {
        id: form.id,
        id_company: form.id_company,
        show_digital_tanks: form.showDigitalTanks,
        show_digital_autotanks: form.showDigitalAutotanks,
        show_digital_stations: form.showDigitalStations
      }
      dispatch({
        type: CHANGE_STATION_CONFIGURATIONS,
        payload: newForm
      })
      dispatch({
        type: SET_COMPANY_DATA,
        payload: newForm
      })
      dispatch(setSnackbar(resp?.message ? resp?.message : "Planta actualizada", 'success'))
      action && action()
    }).catch(err => {
      dispatch(setSnackbar(err))
    })
    dispatch(stopRequestComp('loadingStationsActions'));
  }
}